if(!customElements.get('recommended-products')) {
  class RecommendedProducts extends HTMLElement {
    constructor() {
      super();
      this.productId = this.dataset.productId;
      this.limit = this.dataset.limit;
      this.html = document.createElement('div');
      this.templateContent = this.querySelector('template').content.cloneNode(true);
      this.templateRootElement = this.templateContent.querySelector('.products-carousel-root');
      this.itemsContent = this.templateRootElement.querySelector('.keen-slider, .grid');

      fetch(`/recommendations/products?product_id=${this.productId}&limit=${this.limit}&section_id=recommended_products_view`)
        .then(response => response.text())
        .then((text) => {
          this.html.innerHTML = text;
          const related = this.html.querySelector('.recommended-view');
      
          if(related && related.innerHTML.trim().length) {
            var html = this.itemsContent.classList.contains('grid') ? related.innerHTML.replaceAll('keen-slider-slide', 'grid-item') : related.innerHTML;
            this.style.display = ''; //removes 'display: none'
            this.itemsContent.innerHTML = html;
            this.insertAdjacentElement('beforeend', this.templateRootElement);
          }
        });
    }
  }
  customElements.define('recommended-products', RecommendedProducts);
}